var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Close",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_871",
    "data-name": "Rectangle 871",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close_FILL0_wght300_GRAD0_opsz24_2_",
    "data-name": "close_FILL0_wght300_GRAD0_opsz24 (2)",
    d: "M232.231,329.228l-4.8,4.8a.685.685,0,0,1-.494.2.669.669,0,0,1-.5-.2.707.707,0,0,1,0-1l4.8-4.8-4.8-4.8a.685.685,0,0,1-.2-.494.668.668,0,0,1,.2-.5.707.707,0,0,1,1,0l4.8,4.8,4.8-4.8a.685.685,0,0,1,.494-.2.668.668,0,0,1,.5.2.707.707,0,0,1,0,1l-4.8,4.8,4.8,4.8a.685.685,0,0,1,.2.494.669.669,0,0,1-.2.5.707.707,0,0,1-1,0Z",
    transform: "translate(-220.23 -316.231)",
    fill: "#777374"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.672f3c3af37835d06a71dcb59273115a.svg";
export { ForwardRef as ReactComponent };